import { Contact } from 'typings'

export type BiometyDataType = {
    federalTaxId: string | undefined
    id: string | undefined
    contacts?: Array<Contact>
    origin?: 'otp' | 'recover' | 'cadastro' | undefined
    redirectTo?: string | undefined
    token?: string | undefined
    refreshToken?: string | undefined
    unico?: boolean | undefined
    hasCipPassword?: boolean | undefined
    userRedirectUrl?: string | undefined
    isPasswordChanged?: boolean | undefined
}

export type createBiometryUrlType = {
    createBiometryUrl: {
        id: string
        userRedirectUrl: string
    }
}

export type checkBiometryResultType = {
    checkBiometryResult: {
        status: string
    }
}

export type checkUpdateContactBiometryLimitType = {
    checkUpdateContactBiometryLimit: {
        status: string
    }
}

export interface IHandleBiometry {
    setIsLoading: (value: boolean) => void
    federalTaxId: string
    unicoId: string
}

export interface IHandleCreateLogin {
    setIsLoading: (value: boolean) => void
    contacts: {
        email: string
        cellphone: string
    }
}

export type ContactsBiometry = {
    email: string
    cellphone: string
}

export enum ContactTypeEnum {
    EMAIL = 'EMAIL',
    PHONE = 'CELULAR',
}

export type Contacts = {
    contactType: ContactTypeEnum
    principal: boolean
    value: string
}

export interface IUpdateContacts {
    federalTaxId: string
    contacts: Array<Contacts>
}

export interface IHandleCreateContacts {
    federalTaxId: string
    contacts: {
        email: string
        cellphone: string
    }
}

export enum EOriginOptions {
    UNICO = 'UNICO',
}

export enum EMAIL_ERROR_TYPE {
    UNIQUE = 'UNIQUE',
    INVALID = 'INVALID',
}

export interface UpdateContactsInicialValues {
    cellphone?: string
    email?: string
}

export type updateContactBiometryData = {
    updateContactBiometry: {
        mdmContactId: number
    }
}

export type createDraftFacialBiometryContactsData = {
    createDraftFacialBiometryContacts: {
        status: string
    }
}
